import type { FC } from 'react';
import React, { useState } from 'react';
import { MDText } from 'i18n-react';

import { Modal } from '@motorway/motorway-storybook-cra';

import TextLink from 'Components/shared/TextLink/TextLink';
import { triggerSHFeedbackModalClosedEvent, triggerSHFeedbackModalOpenedEvent } from 'Services/analytics/events';

import { useShouldHideDetailedServiceHistoryCards } from '../useShouldHideDetailedServiceHistoryCards';

import { ServiceHistoryFeedback } from './ServiceHistoryFeedback';
import texts from './ServiceHistoryFeedback.texts';

import styles from './Modal.module.scss';

const LocalT = new MDText(texts);

export const FeedbackModal: FC = () => {
	const shouldHideFeedback = useShouldHideDetailedServiceHistoryCards();
	const [isOpen, setIsOpen] = useState(false);

	const onOpenModal = () => {
		setIsOpen(true);
		triggerSHFeedbackModalOpenedEvent();
	};

	const onCloseModal = () => {
		setIsOpen(false);
		triggerSHFeedbackModalClosedEvent();
	};

	if (shouldHideFeedback) {
		return null;
	}

	return (
		<>
			<TextLink
				classNames={{
					container: styles.link,
					text: styles.linkText,
				}}
				onClick={onOpenModal}
				text={`${LocalT.translate('trigger')}`}
			/>
			{isOpen ? (
				<Modal
					contentClass={styles.modalContent}
					dialogClass={styles.modalDialog}
					dismissModal={onCloseModal}
					size="small"
				>
					<ServiceHistoryFeedback onDismissModal={onCloseModal} />
				</Modal>
			) : null}
		</>
	);
};
